'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'fad';
var iconName = 'microchip-ai';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e1ec';
var svgPathData = ['M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48V24zM280 64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48zm104 0V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h48zm64 112h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zm0 104h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zm0 104h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v48zM336 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H336zm-104 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H232zm-104 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H128zM64 336H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V336zm0-104H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V232zm0-104H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V128z', 'M128 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H128zm94.7 121.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272h35.1L208 231.9zM352 192V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z'];
exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData]
};
exports.faMicrochipAi = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;